import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.9165 6.13674C2.9165 5.74593 3.14417 5.39092 3.49936 5.2279L5.66603 4.23345C6.32846 3.9294 7.08317 4.41341 7.08317 5.14229V14.387C7.08317 14.7798 6.85315 15.1363 6.49519 15.2981L4.32852 16.2779C3.6666 16.5772 2.9165 16.0931 2.9165 15.3667V6.13674Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.0835 5.88674C12.0835 5.49593 11.8558 5.14092 11.5006 4.9779L9.33397 3.98345C8.67154 3.6794 7.91683 4.16341 7.91683 4.89229V14.137C7.91683 14.5298 8.14685 14.8863 8.50481 15.0481L10.6715 16.0279C11.3334 16.3272 12.0835 15.8431 12.0835 15.1167V5.88674Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.9165 5.88674C12.9165 5.49593 13.1442 5.14092 13.4994 4.9779L15.666 3.98345C16.3285 3.6794 17.0832 4.16341 17.0832 4.89229V14.137C17.0832 14.5298 16.8531 14.8863 16.4952 15.0481L14.3285 16.0279C13.6666 16.3272 12.9165 15.8431 12.9165 15.1167V5.88674Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }